import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

const WrapperStyle = styled.div`
    max-width: 100%;
    width: 100vw;
    min-height: 100vh;
    height: 100%;
    margin: 0 auto;
    background: rgb(243, 251, 250);
    overflow: auto;
    box-shadow: 0px 5px 8px rgba(168, 216, 243, 0.5);
    max-width: 430px;
`;

function ContainerMobile() {
    return (
        <div style={{ background: '#FFFFFFE6' }}>
            <WrapperStyle id="em-content">
                <Outlet />
            </WrapperStyle>
        </div>
    );
}

export default ContainerMobile;
